import { z } from 'zod';
import { requiredString } from '../helpers';
export const Bigquery_Query_1_ConfigValidator = z.object({
    connection: requiredString('BigQuery Connection is required'),
    query: requiredString('SQL Query is required'),
    expectedOutput: z.string().optional()
});
//# sourceMappingURL=bigquery-query-1.js.map